var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("verifications.verification_title") } },
    [
      _c("template", { slot: "pageContent" }, [
        _c(
          "div",
          { staticClass: "listPage", staticStyle: { overflow: "hidden" } },
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { md: "12" } },
                  [
                    _c(
                      "div",
                      { staticClass: "requestsList mb-3" },
                      [
                        _c("cm-messages-filter", {
                          staticClass: "researchfilter",
                          staticStyle: {
                            position: "relative",
                            "z-index": "10",
                          },
                          attrs: {
                            isVerifications: "",
                            filterType: "list",
                            propedServiceId: "7",
                            mode: this.mode,
                            randomId: _vm.randomId,
                            buttonCreateVerify: "",
                          },
                          on: {
                            refreshInbox: function ($event) {
                              return _vm.refreshInbox()
                            },
                            applyFilter: function ($event) {
                              return _vm.applyFilter($event)
                            },
                            extractCSV: function ($event) {
                              return _vm.exportList()
                            },
                            createVerify: function ($event) {
                              return _vm.createVerify()
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.activateSpinner
                      ? _c("spinner")
                      : _c("div", [
                          _c(
                            "table",
                            { staticClass: "table table-responsive" },
                            [
                              _c("thead", [
                                _c(
                                  "th",
                                  {
                                    staticClass: "text-center",
                                    staticStyle: { width: "15%" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.$t("attachments.issue_date")
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  {
                                    staticClass: "text-center",
                                    staticStyle: { width: "15%" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.$t("verifications.lblSIREN")
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  {
                                    staticClass: "text-center",
                                    staticStyle: { width: "15%" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.$t("verifications.lblSIRET")
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  {
                                    staticClass: "text-center",
                                    staticStyle: { width: "25%" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.$t(
                                            "verifications.lblSocialReason"
                                          )
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  {
                                    staticClass: "text-center",
                                    staticStyle: { width: "20%" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.$t(
                                            "verifications.verifications_status"
                                          )
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  {
                                    staticClass: "text-center",
                                    staticStyle: { width: "10%" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("verifications.action")) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                [
                                  _vm.inboxMessages.length > 0
                                    ? _vm._l(
                                        _vm.inboxMessages,
                                        function (result, index) {
                                          return _c(
                                            "tr",
                                            {
                                              key: index,
                                              staticClass: "boxRequest",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.redirectDetails(
                                                    result
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-center",
                                                  attrs: {
                                                    title:
                                                      result.DateVerifications,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      result.DateVerifications
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-center",
                                                  attrs: {
                                                    title: result.Siren,
                                                  },
                                                },
                                                [_vm._v(_vm._s(result.Siren))]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-center",
                                                  attrs: {
                                                    title: result.Siret,
                                                  },
                                                },
                                                [_vm._v(_vm._s(result.Siret))]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-center",
                                                  attrs: {
                                                    title: result.SocialReason,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(result.SocialReason)
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-center",
                                                  attrs: {
                                                    title:
                                                      _vm.getKYCVerificationsStatus(
                                                        result.Status
                                                      ),
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "b-container",
                                                    { attrs: { fluid: "" } },
                                                    [
                                                      _c(
                                                        "b-row",
                                                        [
                                                          _c(
                                                            "b-col",
                                                            {
                                                              attrs: {
                                                                sm: "2",
                                                              },
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "btn btn-icon",
                                                                class:
                                                                  _vm.getKYCVerificationsIcon(
                                                                    result.Status
                                                                  ),
                                                              }),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "b-col",
                                                            {
                                                              staticClass:
                                                                "pt-2",
                                                              attrs: {
                                                                sm: "10",
                                                              },
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.getKYCVerificationsStatus(
                                                                      result.Status
                                                                    )
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-center" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "fileClickButton",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.redirectDetails(
                                                            result,
                                                            result.IdKYCVerifications
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "common.cnslt"
                                                            )
                                                          ) +
                                                          "\n                      "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        }
                                      )
                                    : _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass: "noResult",
                                            attrs: { colspan: "6" },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t("common.no_result")
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ]),
                                ],
                                2
                              ),
                            ]
                          ),
                        ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12" } },
                  [
                    _c("cm-pagination", {
                      attrs: {
                        maxResultsByPage: _vm.paginationObject.maxResults,
                        firstIndex: _vm.paginationObject.firstIndex,
                        nbResultsTotal: _vm.paginationObject.nbResultsTotal,
                        refreshEvent: _vm.paginationObject.refresh,
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }